module.exports = __webpack_public_path__ + "img/1J7.1154ed8c.png";